import React from 'react';
import { openModal } from 'modal-core-components';

import SubscriptionCancellationModalContainer from './SubscriptionCancellationModalContainer';

const openSubscriptionCancellationModal = ({ isTrialUser, onCancellationRequest }) =>
  openModal(closeModal => (
    <SubscriptionCancellationModalContainer
      isTrialUser={isTrialUser}
      onClose={closeModal}
      onCancellationRequest={onCancellationRequest}
    />
  ));

export default openSubscriptionCancellationModal;
